import { DISNEY_FOLDER_NAMES } from './clients/DISNEY/folder-names';
import { RESUMIDO_FOLDER_NAMES } from './clients/RESUMIDO/folder-names';
import { GPOVALLAS_FOLDER_NAMES } from './clients/GPOVALLAS/folder-names';
import { MACRO_FOLDER_NAMES } from './clients/MACRO/folder-names';
import { LUZU_FOLDER_NAMES } from './clients/LUZU/folder-names';
import { DEFAULT_FOLDER_NAMES } from './clients/default-folders';

export const BANNER_TYPE_TO_FOLDER = {
  ...DISNEY_FOLDER_NAMES,
  ...RESUMIDO_FOLDER_NAMES,
  ...GPOVALLAS_FOLDER_NAMES,
  ...MACRO_FOLDER_NAMES,
  ...LUZU_FOLDER_NAMES,
  ...DEFAULT_FOLDER_NAMES
} as const;
